import { Navigate, useSearchParams } from "react-router-dom";

/** Legacy Jinja-era URL → React checkout. */
export function LegacyCheckoutRedirect() {
  const [sp] = useSearchParams();
  const g = sp.get("guild");
  const p = sp.get("plan") || "monthly";
  if (g) {
    return (
      <Navigate
        to={`/premium/${g}/checkout?plan=${encodeURIComponent(p)}`}
        replace
      />
    );
  }
  return <Navigate to="/premium" replace />;
}
